import backgroundJobApi, { IAddBackgroundJobPayload, IBackgroundJob, IGetListBackgroundJobPayload } from '@/api/backgroundJob'

import { ACTION_BACKGROUND_JOB } from './actions';

export default {
  state: {
    items: [] as IBackgroundJob[],
    pagination: { totalItems: 0, pageSize: 0, page: 0 },
    loading: false,
  },
  actions: {
    [ACTION_BACKGROUND_JOB.LOAD_ITEMS]: async ({ commit }, payload: IGetListBackgroundJobPayload) => {
      return await backgroundJobApi.list(payload).then(resp => {
        commit(ACTION_BACKGROUND_JOB.SET_ITEMS, {
          items: resp.items,
          pagination: {
            totalItems: resp.total_items ?? 0,
            pageSize: payload.page_size,
            page: payload.page,
          },
        });
        return resp;
      });
    },
    [ACTION_BACKGROUND_JOB.ADD_ITEM]: async ({ state, dispatch }, payload: IAddBackgroundJobPayload) => {
      await backgroundJobApi.add(payload).then(() => {
        // Refresh the list after adding a new background job
        dispatch(ACTION_BACKGROUND_JOB.LOAD_ITEMS, { app_id: payload.app_id, page: state.pagination.page, page_size: state.pagination.pageSize, is_test_mode: payload.is_test_mode });
      });
    },
  },
  mutations: {
    [ACTION_BACKGROUND_JOB.SET_ITEMS]: (state, { items, pagination }) => {
      state.items = items;
      state.pagination = pagination;
    },
  },
}
